<template>
  <div class="confirm-btn-group">
    <Button class="default-btn" @click="$emit('cancel')" shape="round">{{$t('common.Deny')}}</Button>
    <Button class="primary-btn" @click="$emit('confirm')" shape="round">{{$t('home.Accept')}}</Button>
  </div>
</template>
<script>
// 询问性的按钮组: 接受,拒绝
import { Button } from 'ant-design-vue'
export default {
  name: 'ConfirmBtnGroup',
  components: {
    Button
  },
  props: {
    layout: {
      type: String, // 两个按钮的位置关系 'horizontal', 'vertical'
      default: 'horizontal'
    }
  },
  computed: {
    rootClasses() {
      return `confirm-btn-group layout-${this.layout}`
    }
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
.confirm-btn-group {
  display: flex;
  justify-content: space-between;
  ::v-deep .ant-btn {
    .medium-font(16);
    height: 40px;
    border-radius: 20px;
    padding: 0 40px;
    border-color: transparent;
  }

  .default-btn {
    box-shadow: 0px 6px 10px 0px rgba(207, 222, 241, 0.7);
    color: #000;
  }

  .primary-btn {
    box-shadow: 0px 5px 10px 0px rgba(35, 108, 255, 0.5);
    background: linear-gradient(
      154deg,
      #236cff 0%,
      rgba(35, 108, 255, 0.8) 100%
    );
    color: #fff;
  }
}
</style>
